<div class="rv-center my-large"><logo></logo></div>
<div
  class="form-container"
  *ngIf="_.submitLoad.loading || _.submitLoad.error || !_.showSuccess"
>
  <p class="instructions">Enter your email to receive a single sign-on link</p>
  <form class="rv-rows large" (ngSubmit)="_.validateAndSubmit()">
    <div class="rv-rows large">
      <div>
        <riv-text-field
          autocomplete="email"
          name="email"
          label="Email"
          placeholder="Enter your email"
          type="email"
          [value]="_.email"
          (valueChange)="_.setEmail($event); _.clearAllErrors()"
          size="large"
          [state]="_.emailHasIssue ? 'error' : 'valid'"
        ></riv-text-field>
      </div>
      <submit-error *ngIf="_.clientSideError">
        {{ _.clientSideError }}
      </submit-error>
      <submit-error *ngIf="_.submitLoad.error">
        {{ _.submitLoad.error.error }}
      </submit-error>
      <button
        rivButton
        [variant]="'primary'"
        [size]="'large'"
        [full]="true"
        [disabled]="_.submitLoad.loading"
        type="submit"
      >
        {{ _.submitLoad.loading ? 'Submitting...' : 'Submit' }}
      </button>
    </div>
  </form>
  <div class="rv-body-medium rv-low-contrast mt-xlarge">
    <a
      rivButton
      [variant]="'basic'"
      [size]="'large'"
      [full]="true"
      routerLink="/login"
      [queryParams]="{ email: _.email }"
    >
      Back to login
    </a>
  </div>
</div>
<div
  class="confirmation-container"
  *ngIf="!_.submitLoad.loading && !_.submitLoad.error && _.showSuccess"
>
  <h2 class="title">Request submitted</h2>
  <p class="instructions">
    If an account exists for {{ _.email }}, you will receive an email with
    instructions on how to log in.
  </p>
  <button
    rivButton
    class="primary"
    [full]="true"
    [size]="'large'"
    routerLink="/login/password"
    [queryParams]="{ email: _.email }"
  >
    Go to login
  </button>
</div>
<div
  *ngIf="!_.envIsZelis"
  class="rv-body-medium rv-low-contrast rv-center my-xlarge"
>
  Need help? <a class="rv-link" (click)="openIntercom()">Contact support.</a>
</div>
